import React, {useEffect, useRef} from "react";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";


// components
import {GenericButton} from "../../../../components/buttons/customButtons";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import ActivityForm from "../activities/_activityForm";

// labels
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";

// service
import {activityService} from "../../../../jwt/_services/core/activityService";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../../redux/actions/generics/IndexedActions";




const ListActivities = (props) => {
    const {mainPath, categoriesPath, activitiesPath} = props

    const udnState = useSelector(state => getStateByPath(state, mainPath));
    const categoriesState = useSelector(state => getStateByPath(state, categoriesPath));
    const activitiesState = useSelector(state => getStateByPath(state, activitiesPath));

    const formModalRef = useRef(null);

    const {domainObject:udn, app:{fbDataBase}} = udnState?.data || {};
    const {domainObject:category} = categoriesState?.data || {};
    const {listDomainObjects:activities, loading} = activitiesState?.data || {};



    useEffect(() => {
        searchActivities()
    }, [category]);



    const searchActivities = () => {
        if(!category?.id || !udn?.id)
            return;




        const requestData = {
            fbDataBase: {id: fbDataBase?.id},
            item: {
                category: {id: category?.id},
                udn: {id: udn?.id},
                status: null
            }
        }

        genericIndexedActions.search(activitiesPath, activityService, 0, 2000, requestData)

    }




    const createActivity = () => {
        props.setItem(activitiesPath, null);
        props.setForm(activitiesPath);

        formModalRef.current.showModal();
    }


    const editActivity = data => {
        props.setItem(activitiesPath, data);
        props.setForm(activitiesPath, true, false, false);

        formModalRef.current.showModal();
    }




    const onDelete = itemId => genericIndexedActions.delete(activitiesPath, activityService, itemId, fbDataBase?.id)






    const renderContent = (item, index) => <div className={'sauser-item' + (item.status ? '' : ' innactive')}>
        <h4>{index + 1}</h4>
        <div className={'sub-category-item-image'}>
            {
                item?.mediaUrl ? <img className={'image' + (!item?.status ? ' grayscale' : '')}
                    src={item?.mediaUrl}
                    alt={item?.title}
                /> : <span className="fa-stack fa-lg">
                    <i className="fa fa-picture-o fa-stack-1x"></i>
                    <i className="fa fa-ban fa-stack-2x"></i>
                </span>
            }
        </div>
        <label className="sauser-item-title">
            <b>{item?.name}</b>
        </label>
        <div className="float-left">
            <GenericButton
                    style={'table'}
                    toolTip={TT_EDIT}
                    icon={'fa-pen'}
                    permission={'edit'}
                    onClick={_ => editActivity(item)}/>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_REMOVE}
                    icon={'fa-minus'}
                    permission={'edit'}
                    onClick={() => onDelete(item?.id)}
                />
        </div>
    </div>


    return <>
        {
            loading && <center>
                <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"/><br/>
                <span>Cargando Actividades...</span>
            </center>
        }

        {
            !loading && category !== null && <>
                <div className="bg-light border-bottom p-3 mb-2em">
                    Actividades asociadas
                    <div className="float-right" style={{marginTop:"-10px"}}>
                        <GenericButton
                            style={'success-secondary'}
                            label={'Crear y Vinvular Actividad'}
                            toolTip={'Agregar Actividad'}
                            icon={'fa-plus'}
                            permission={'add'}
                            onClick={createActivity}
                        />
                    </div>
                </div>
            </>
        }

        {
            !loading && activities?.length === 0 && category !== null && <div className="alert alert-info">
                No hay actividades asignadas a esta categoría.
            </div>
        }

        {
            !loading && activities?.length > 0 && <DragDropList
                items={activities?.sort((a, b) => a.showOrder - b.showOrder)}
                renderContent={renderContent}
                onReorder={() => {}}
                orientationHV={'vertical-container'} // CSS class para orientar los elementos horizontalmente
                className={'sub-category-section-list'}
            />
        }

        <ActivityForm
            ref={formModalRef}
            mainPath={mainPath}
            activitiesPath={activitiesPath}
            categoriesPath={categoriesPath}
        />
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})


export default connect(mapStateToProps, mapActionsToProps)(ListActivities);